import {
  getOrderEvents,
  reorderEventsEcommerce,
  getOrderEventsMktp,
  reorderEventsMktp,
} from "@/api";

const state = {
  orderedEvents: [],
  unorderedEvents: [],
  totalOrderedEvents: 0,
  totalUnorderedEvents: 0,

  ordering_loading: false,
  orderedEvents_loading: false,

  orderedEventsMktp: [],
  unorderedEventsMktp: [],
  totalOrderedEventsMktp: 0,
  totalUnorderedEventsMktp: 0,

  ordering_loadingMktp: false,
  orderedEvents_loadingMktp: false,
};
const getters = {
  orderedEvents: state => state.orderedEvents,
  unorderedEvents: state => state.unorderedEvents,
  totalOrderedEvents: state => state.totalOrderedEvents,
  totalUnorderedEvents: state => state.totalUnorderedEvents,
  ordering_loading: state => state.ordering_loading,
  orderedEvents_loading: state => state.orderedEvents_loading,

  orderedEventsMktp: state => state.orderedEventsMktp,
  unorderedEventsMktp: state => state.unorderedEventsMktp,
  totalOrderedEventsMktp: state => state.totalOrderedEventsMktp,
  totalUnorderedEventsMktp: state => state.totalUnorderedEventsMktp,
  ordering_loadingMktp: state => state.ordering_loadingMktp,
  orderedEvents_loadingMktp: state => state.orderedEvents_loadingMktp,
};
const actions = {
  async fetchOrderEvents({ commit }, params) {
    commit("setOrderedEventsLoading", true);
    try {
      const response = await getOrderEvents(params);
      const { ordenado, nao_ordenado, total_ordenado, total_nao_ordenado } =
        response.data;

      commit("setOrderedEvents", ordenado);
      commit("setUnorderedEvents", nao_ordenado);
      commit("setTotalOrderedEvents", total_ordenado);
      commit("setTotalUnorderedEvents", total_nao_ordenado);
      commit("setOrderedEventsLoading", false);
    } catch (error) {
      commit("setOrderedEventsLoading", false);
      throw new Error(error);
    }
  },
  async reorderEvents({ commit }, data) {
    const { idproduto, idcombo, ordem, ult_pos } = data;
    const params = {
      ordem,
      ult_pos,
    };

    if (idproduto) {
      params.idproduto = idproduto;
    } else {
      params.idcombo = idcombo;
    }
    try {
      commit("setOrderingLoading", true);
      await reorderEventsEcommerce(params);
      commit("setOrderingLoading", false);
      this.dispatch("showSnackbarSuccess", "Ordenação realizada com sucesso.");
    } catch (error) {
      commit("setOrderingLoading", false);
      this.dispatch("showSnackbarError", "Erro ao ordenar.");
      throw new Error(error);
    }
  },
  async fetchOrderEventsMktp({ commit }, params) {
    commit("setOrderedEventsLoadingMktp", true);
    try {
      const response = await getOrderEventsMktp(params);
      const { ordenado, nao_ordenado, total_ordenado, total_nao_ordenado } =
        response.data;

      commit("setOrderedEventsMktp", ordenado);
      commit("setUnorderedEventsMktp", nao_ordenado);
      commit("setTotalOrderedEventsMktp", total_ordenado);
      commit("setTotalUnorderedEventsMktp", total_nao_ordenado);
      commit("setOrderedEventsLoadingMktp", false);
    } catch (error) {
      commit("setOrderedEventsLoadingMktp", false);
      throw new Error(error);
    }
  },
  async reorderEventsMktp({ commit }, data) {
    const { idproduto, idcombo, ordem, loja, ult_pos } = data;
    const params = {
      ordem,
      loja,
      ult_pos,
    };

    if (idproduto) {
      params.idproduto = idproduto;
    } else {
      params.idcombo = idcombo;
    }
    try {
      commit("setOrderingLoading", true);
      await reorderEventsMktp(params);
      commit("setOrderingLoading", false);
      this.dispatch("showSnackbarSuccess", "Ordenação realizada com sucesso.");
    } catch (error) {
      commit("setOrderingLoading", false);
      this.dispatch("showSnackbarError", "Erro ao ordenar.");
      throw new Error(error);
    }
  },
};
const mutations = {
  setOrderedEventsLoading: (state, loading) =>
    (state.orderedEvents_loading = loading),
  setOrderingLoading: (state, loading) => (state.ordering_loading = loading),
  setOrderedEvents(state, orderedEvents) {
    state.orderedEvents = orderedEvents;
  },
  setUnorderedEvents(state, unorderedEvents) {
    state.unorderedEvents = unorderedEvents;
  },
  setTotalOrderedEvents: (state, totalOrderedEvents) =>
    (state.totalOrderedEvents = totalOrderedEvents),
  setTotalUnorderedEvents: (state, totalUnorderedEvents) =>
    (state.totalUnorderedEvents = totalUnorderedEvents),

  setOrderedEventsLoadingMktp: (state, loading) =>
    (state.orderedEvents_loadingMktp = loading),
  setOrderingLoadingMktp: (state, loading) =>
    (state.ordering_loadingMktp = loading),
  setOrderedEventsMktp(state, orderedEvents) {
    state.orderedEventsMktp = orderedEvents;
  },
  setUnorderedEventsMktp(state, unorderedEvents) {
    state.unorderedEventsMktp = unorderedEvents;
  },
  setTotalOrderedEventsMktp: (state, totalOrderedEvents) =>
    (state.totalOrderedEventsMktp = totalOrderedEvents),
  setTotalUnorderedEventsMktp: (state, totalUnorderedEvents) =>
    (state.totalUnorderedEventsMktp = totalUnorderedEvents),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
